import usFlag from "../assets/images/flags/us.jpg"
import spain from "../assets/images/flags/spain.jpg"
import germany from "../assets/images/flags/germany.jpg"
import italy from "../assets/images/flags/italy.jpg"
import russia from "../assets/images/flags/russia.jpg"
import global from "../assets/images/flags/global.jpg"
import india from "../assets/images/flags/india.png"


const languages = {
  IN: {
    label: "India",
    flag: india,
  },
  GB: {
    label: "Global",
    flag: global,
  }
}

export default languages
